import axios from "axios";

export function getAllStates() {
  return axios({
    method: "GET",
    url: "/api/State/states",
    headers: {
      "Content-Type": "application/json"
    }
  });
}
